var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerClasses},_vm._l((_vm.bigNumbers),function(item){return _c('SubscriptionBigNumber',_vm._b({key:item.id,staticClass:"snap-item mb-2"},'SubscriptionBigNumber',item,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }